export const noop = () => {};

export const noEvent = event => event.stopPropagation();
